import classes from "./BoxEntity.module.css";

const BoxEntity = ({ className, icon, content, styleValue, value }) => {
  return (
    <div className={[classes.boxEntity, className].join(" ")}>
      <div className={classes.boxEntity_icon}>
        {icon && icon !== "-" && <img src={icon} alt="icon" width="32px" />}
        <div className={classes.boxEntity_content}>{content}</div>
      </div>
      <div className={classes.boxEntity_value} style={styleValue}>
        {value}
      </div>
    </div>
  );
};
export default BoxEntity;
